import React from "react";
import { Tooltip, TooltipProps } from "../Tooltip/Tooltip";
import { OverlayTrigger, OverlayTriggerProps } from "../OverlayTrigger";

interface TooltipOverlayProps
  extends Omit<OverlayTriggerProps, "overlay">,
    Omit<TooltipProps, "children"> {
  tooltipChildren: React.ReactNode;
}

// TODO: combine / rename Tooltip's x/y coords and OverlayTrigger's x/y offsets into a single unit
export const TooltipOverlay: React.FC<TooltipOverlayProps> = ({
  tooltipChildren,
  coords,
  horizontalShift,
  verticalShift,
  design,
  multiline,
  children,
  trigger,
  placement,
  delay,
  exitOnBackgroundClick,
  loseFocusOnScroll,
  onExit,
  customTrigger,
  yoffset,
  xoffset,
}) => {
  if (!tooltipChildren) {
    return children;
  }

  return (
    <OverlayTrigger
      trigger={trigger}
      placement={placement}
      delay={delay}
      exitOnBackgroundClick={exitOnBackgroundClick}
      loseFocusOnScroll={loseFocusOnScroll}
      onExit={onExit}
      customTrigger={customTrigger}
      yoffset={yoffset}
      xoffset={xoffset}
      overlay={
        <Tooltip
          coords={coords}
          horizontalShift={horizontalShift}
          verticalShift={verticalShift}
          design={design}
          multiline={multiline}
        >
          {tooltipChildren}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
